import { Routes, Route, Navigate } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { selectIsAdmin } from "../../store/authSelectors";
import { MediumHeader } from "../../styles/Typography";
import Menu from "../Menu/Menu";
import PrivateRoute from "./PrivateRoute";
import ProtectedRoute from "./ProtectedRoute";
import Users from "../../pages/Users/Users";
import UserDetails from "../../pages/UserDetails/UserDetails";
import UserFormPage from "../../pages/CRUDPages/UserFormPage";
import Companies from "../../pages/Companies/Companies";
import CompanyDetails from "../../pages/CompanyDetails/CompanyDetails";
import CompanyFormPage from "../../pages/CRUDPages/CompanyFormPage";
import Projects from "../../pages/Projects/Projects";
import ProjectDetails from "../../pages/ProjectDetails/ProjectDetails";
import ProjectFormPage from "../../pages/CRUDPages/ProjectFormPage";
import Licenses from "../../pages/Licenses/Licenses";
import LicenseDetails from "../../pages/LicenseDetails/LicenseDetails";
import LicenseFormPage from "../../pages/CRUDPages/LicenseFormPage";
import InstanceDetails from "../../pages/InstanceDetails/InstanceDetails";
import { Main, PageNotFound, StyledLink } from "./AppLayout.styles";

const AppLayout = () => {
  const user = useAppSelector((state) => state.auth.user);
  const isAdmin = useAppSelector(selectIsAdmin);

  return (
    <PrivateRoute>
      <Menu />
      <Main>
        <Routes>
          <Route
            path="/"
            element={
              <Navigate
                to={isAdmin ? "/companies" : `/users/${user?.id}`}
                replace
              />
            }
          />
          <Route
            path="/users"
            element={
              <ProtectedRoute adminOnly>
                <Users />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users/:id"
            element={
              <ProtectedRoute>
                <UserDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users/form"
            element={
              <ProtectedRoute adminOnly>
                <UserFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/companies"
            element={
              <ProtectedRoute adminOnly>
                <Companies />
              </ProtectedRoute>
            }
          />
          <Route
            path="/companies/:id"
            element={
              <ProtectedRoute adminOnly>
                <CompanyDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/companies/form"
            element={
              <ProtectedRoute adminOnly>
                <CompanyFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects"
            element={
              <ProtectedRoute adminOnly>
                <Projects />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects/:id"
            element={
              <ProtectedRoute adminOnly>
                <ProjectDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects/form"
            element={
              <ProtectedRoute adminOnly>
                <ProjectFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/instances/:id"
            element={
              <ProtectedRoute adminOnly>
                <InstanceDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/licenses"
            element={
              <ProtectedRoute adminOnly>
                <Licenses />
              </ProtectedRoute>
            }
          />
          <Route
            path="/licenses/:id"
            element={
              <ProtectedRoute adminOnly>
                <LicenseDetails />
              </ProtectedRoute>
            }
          />
          <Route
            path="/licenses/form"
            element={
              <ProtectedRoute adminOnly>
                <LicenseFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/companies/:companyId/licenses/form"
            element={
              <ProtectedRoute adminOnly>
                <LicenseFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/users/:userId/licenses/form"
            element={
              <ProtectedRoute adminOnly>
                <LicenseFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/projects/:projectId/licenses/form"
            element={
              <ProtectedRoute adminOnly>
                <LicenseFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/companies/:companyId/users/form"
            element={
              <ProtectedRoute adminOnly>
                <UserFormPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="*"
            element={
              <PageNotFound>
                <MediumHeader>
                  Такая страница не найдена. <br /> Попробуйте вернуться назад
                  или перейти на{" "}
                  <StyledLink to="/">главную страницу.</StyledLink>
                </MediumHeader>
              </PageNotFound>
            }
          />
        </Routes>
      </Main>
    </PrivateRoute>
  );
};

export default AppLayout;
